import * as React from 'react'
import { WorkingMessageCard } from './WorkingMessageCard'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const WorkingMessageCardExamples = () => {
  return (
    <div className="WorkingMessageCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <WorkingMessageCard userId="abc123" seconds={132} />
      </Provider>
    </div>
  )
}
